module.exports = __webpack_public_path__ + "img/square-caret-right.5a9e71ff.svg";